import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
// import IAreaPlan from '../interfaces/IAreaPlan';
import Layout from '~/components/Layout';
import type { IArea } from '../interfaces/IArea';



export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IArea>();
  const fields = [
    { name: 'name', type: 'string', required: true },
    { name: 'acronym', type: 'string', required: true },
    { name: 'polygon', type: 'string', required: true },
    { name: 'area_plan_id', type: 'selectAutoComplete', model: 'area-plan', placeholder: 'Area Plan', required: true },
    { name: 'color', type: 'string', color: true, required: true },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate model={'area'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Area successfully created!'}
        title={'Add area'}
        subheader={'Add area'}
        setFormValue={setFormValue} />
    </Layout>
  )
}
